import './styles.scss'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import operatorActions from '../../../redux/actions/user'
import { fetchUsers } from '../../../redux/actions/cv_users'
import { fetchAssignedUsers } from '../../../redux/actions/assignedUsers'
import { IconSwitch } from 'components/common'
import { MultiBrandsAndDelegations, SelectWithLabel } from 'components/Form'
import TagSelector from 'components/TagSelector'
import { apiPools } from 'api'

const _ = require('lodash')

const SideMenuFilters = ({ options, onChange }) => {
  const powerUser = useSelector(state => state.user)
  const dispatch = useDispatch()
  const [isLoadingCategories, setIsLoadingCategories] = useState(false)
  const [isOpenCategorySelector, setIsOpenCategorySelector] = useState(false)
  const [allCategories, setAllCategories] = useState([])

  const updateOperator = async (frontOptions) => {
    return dispatch(
      operatorActions.updateOperator({
        ...powerUser,
        frontOptions
      })
    )
  }

  const onChangeFilter = async ({ key, value }) => {
    let itemValue = value || !_.get(powerUser.frontOptions, `${key}`)
    let optionsFront = { ...powerUser.frontOptions || {} }

    try {
      if (key === 'filter') {
        let frontOptions
        options.filter.keys.forEach(it => {
          frontOptions = {
            ...frontOptions,
            [it]: it.toLowerCase().includes('order') || it.toLowerCase().includes('sort')
              ? 'desc'
              : it.toLowerCase().includes('selecttype')
                ? options.selectTypeOptions[0]
                : it.toLowerCase().includes('channels')
                  ? []
                  : it.toLowerCase().includes('brandsanddelegations')
                    ? { brands: [], delegations: [] }
                    : it.toLowerCase().includes('categories')
                      ? []
                      : it.toLowerCase().includes('poolCategories')
                        ? []
                        : false

          }
        })

        optionsFront = {
          ...powerUser.frontOptions,
          ...frontOptions
        }

      } else {
        optionsFront[key] = itemValue
      }

      await updateOperator(optionsFront)
    } catch(error) {
      console.error(error)
    }

    if (key === 'filter') {
      if (!options?.filter?.value) return
      if (options?.filter?.pool === 'users') {
        dispatch(fetchUsers({
          order: 'desc',
          withPendingMsg: false,
          withNotAssigned: false,
          outbound: false,
          selectType: null,
          channels: [],
          brands: [],
          delegations: [],
          categories: [],
        }))
      }
      if (options?.filter?.pool === 'assignedUsers') {
        dispatch(fetchAssignedUsers({
          order: 'desc',
          withPendingMsg: false,
          onlyAssignedToMe: false,
          outbound: false,
          selectType: null,
          channels: [],
          brands: [],
          delegations: [],
          categories: []
        }))
      }
      if (options?.filter?.pool === 'poolLists') {
        onChange({
          poolListSort: '',
          poolListCheckedPendingMsg: false,
          poolListNotAssigned: false,
          poolListOutbound: false,
          poolListOrderByList: optionsFront.poolListOrder,
          poolCategories: []
        })
      }
    } else {
      if (options?.filter?.pool === 'users') {
        if ('poolOrder' === key) dispatch(fetchUsers({ order: itemValue }))
        if ('switchPending' === key) dispatch(fetchUsers({ withPendingMsg: itemValue }))
        if ('poolNotAssigned' === key) dispatch(fetchUsers({ withNotAssigned: itemValue }))
        if ('poolMainOutbound' === key) dispatch(fetchUsers({ outbound: itemValue }))
        if ('poolSelectType' === key) dispatch(fetchUsers({ selectType: itemValue }))
        if ('poolChannels' === key) dispatch(fetchUsers({ channels: itemValue }))
        if ('poolBrandsAndDelegations' === key) dispatch(fetchUsers(itemValue))
        if ('poolCategories' === key) dispatch(fetchUsers({ categories: itemValue }))
      } else if (options?.filter?.pool === 'assignedUsers') {
        if ('orderAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: itemValue,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: optionsFront.outboundAssigned,
            selectType: optionsFront.selectTypeAssigned,
            channels: optionsFront.channelsAssigned,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('switchPendingAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: itemValue,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: optionsFront.outboundAssigned,
            selectType: optionsFront.selectTypeAssigned,
            channels: optionsFront.channelsAssigned,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('checkedOnlyToMeAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: itemValue,
            outbound: optionsFront.outboundAssigned,
            selectType: optionsFront.selectTypeAssigned,
            channels: optionsFront.channelsAssigned,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('outboundAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: itemValue,
            selectType: optionsFront.selectTypeAssigned,
            channels: optionsFront.channelsAssigned,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('selectTypeAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: optionsFront.outboundAssigned,
            selectType: itemValue,
            channels: optionsFront.channelsAssigned,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('channelsAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: optionsFront.outboundAssigned,
            selectType: optionsFront.selectTypeAssigned,
            channels: itemValue,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('brandsAndDelegationsAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: optionsFront.outboundAssigned,
            selectType: optionsFront.selectTypeAssigned,
            channels: optionsFront.channelsAssigned,
            brands: itemValue.brands || [],
            delegations: itemValue.delegations || [],
            categories: optionsFront.categoriesAssigned || []
          }))
        } else if ('categoriesAssigned' === key) {
          dispatch(fetchAssignedUsers({
            order: optionsFront.orderAssigned,
            withPendingMsg: optionsFront.switchPendingAssigned,
            onlyAssignedToMe: optionsFront.checkedOnlyToMeAssigned,
            outbound: optionsFront.outboundAssigned,
            selectType: optionsFront.selectTypeAssigned,
            channels: optionsFront.channelsAssigned,
            brands: optionsFront.brandsAndDelegationsAssigned?.brands || [],
            delegations: optionsFront.brandsAndDelegationsAssigned?.delegations || [],
            categories: itemValue || []
          }))
        }
      } else if (options?.filter?.pool === 'poolLists') {
        if ('poolListSort' === key) {
          onChange({
            poolListSort: itemValue,
            poolListCheckedPendingMsg: optionsFront.poolListCheckedPendingMsg,
            poolListNotAssigned: optionsFront.poolListNotAssigned,
            poolListOutbound: optionsFront.poolListOutbound,
            poolListOrderByList: optionsFront.poolListOrder,
          })
        }
        if ('poolListCheckedPendingMsg' === key) {
          onChange({
            poolListSort: optionsFront.poolListSort,
            poolListCheckedPendingMsg: itemValue,
            poolListNotAssigned: optionsFront.poolListNotAssigned,
            poolListOutbound: optionsFront.poolListOutbound,
            poolListOrderByList: optionsFront.poolListOrder,
          })
        }
        if ('poolListNotAssigned' === key) {
          onChange({
            poolListSort: optionsFront.poolListSort,
            poolListCheckedPendingMsg: optionsFront.poolListCheckedPendingMsg,
            poolListNotAssigned: itemValue,
            poolListOutbound: optionsFront.poolListOutbound,
            poolListOrderByList: optionsFront.poolListOrder,
          })
        }
        if ('poolListOutbound' === key) {
          onChange({
            poolListSort: optionsFront.poolListSort,
            poolListCheckedPendingMsg: optionsFront.poolListNotAssigned,
            poolListNotAssigned: optionsFront.poolListCheckedPendingMsg,
            poolListOutbound: itemValue,
            poolListOrderByList: optionsFront.poolListOrder,
          })
        }
      }
    }
  }

  const onCategoryClick = async (selectedCategory) => {
    try {
      let currentCategories = options.categories?.value ? options.categories.value : []

      if (currentCategories.includes(selectedCategory.category)) {
        currentCategories = currentCategories.filter(category => category !== selectedCategory.category)
      } else {
        currentCategories.push(selectedCategory.category)
      }

      onChangeFilter({
        key: options?.categories?.key,
        value: currentCategories
      })
    } catch (error) {
      console.error('error: ', error)
    }
  }

  const debounce = (func, delay) => {
    let timeoutId
    return function(...args) {
      const context = this
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => func.apply(context, args), delay)
    }
  }

  const onSearchCategory = debounce((value) => {
    getCategories({ text: value })
  }, 300)


  const getCategories = async ({ text = '', pageSize = 50, pageNumber = 0 }) => {
    try {
      setIsLoadingCategories(true)
      const body = {
        text,
        pageSize,
        pageNumber,
      }
      const { data } = await apiPools.getCategories(body)

      setAllCategories([
        {
          name: I18n.t('label_without_category'),
          isFolder: false,
          category: 'label_without_category'
        },
        ...data
      ])
    } catch (error) {
      console.error('error: ', error)
    } finally {
      setIsLoadingCategories(false)
    }
  }

  const onOpenCategorySelector = async (isOpening = true) => {
    if (isOpening) {
      await getCategories({ text: '', pageSize: 50, pageNumber: 0 })
      setIsOpenCategorySelector(true)
    } else {
      setIsOpenCategorySelector(false)
    }
  }

  return (
    <div className='side-menu-filters'>
      <div className='side-menu-filters__switches-container'>
        <div className='side-menu-filters__switches'>
          <div className='side-menu-filters__left-switches'>
            <IconSwitch
              height='11px'
              iconType='order'
              isActive={options?.order?.value === 'asc' ? true : false}
              tooltip={options?.order?.tooltip}
              onClick={() => {
                onChangeFilter({
                  key: options?.order?.key,
                  value: options?.order?.value === 'asc' ? 'desc' : 'asc'
                })
              }}
            />
            <IconSwitch
              height='12px'
              iconType='unread'
              isActive={options?.notRead?.value}
              tooltip={options?.notRead?.tooltip}
              onClick={() => onChangeFilter({ key: options?.notRead?.key })}
            />
            {options.notAssign ? (
              <IconSwitch
                height='12px'
                iconType='none-asign'
                isActive={options?.notAssign?.value}
                tooltip={options?.notAssign?.tooltip}
                onClick={() => onChangeFilter({ key: options?.notAssign?.key })}
              />
            ) : null}
            {options?.onlyToMe ? (
              <IconSwitch
                height='10px'
                iconType='one-one'
                isActive={options?.onlyToMe?.value}
                tooltip={options?.onlyToMe?.tooltip}
                onClick={() => onChangeFilter({ key: options?.onlyToMe?.key })}
              />
            ) : null}
            {
              options?.categories ? (
                <>
                  <IconSwitch
                    height='18px'
                    iconType='categories'
                    isActive={options.categories?.value?.length > 0 || false}
                    tooltip={options.categories?.tooltip}
                    onClick={onOpenCategorySelector}
                  />
                  <TagSelector
                    onCategoryClick={onCategoryClick}
                    allCategories={allCategories}
                    searchCategory={onSearchCategory}
                    isOpen={isOpenCategorySelector}
                    setIsOpen={onOpenCategorySelector}
                    selectedCategories={options.categories?.value || []}
                    isLoading={isLoadingCategories}
                    forPoolFilter
                  />
                </>
              ) : null
            }
            <IconSwitch
              height='10px'
              iconType='outbound'
              isActive={options?.outbound?.value}
              tooltip={options?.outbound?.tooltip}
              onClick={() => onChangeFilter({ key: options?.outbound?.key })}
            />
          </div>
          <IconSwitch
            height='13px'
            iconType='filter'
            isActive={options?.filter?.value}
            tooltip={options?.filter?.tooltip}
            onClick={() => onChangeFilter({ key: options?.filter?.key })}
          />
        </div>
      </div>
      <div className='side-menu-filters__selectors-container'>
        <SelectWithLabel
          classNameWrapper='side-menu-filters__selector'
          options={options.selectTypeOptions}
          value={options.selectType.value || options.selectTypeOptions[0]}
          onChange={value => onChangeFilter({ key: options.selectType.key, value })}
        />
        <SelectWithLabel
          multi
          isClearable
          isRequiredAll
          classNameWrapper='side-menu-filters__selector'
          placeholder={I18n.t('dashboard_channels')}
          options={options.channelsOptions}
          value={options.channels.value}
          selectedValues={options.channels.value}
          onChange={value => onChangeFilter({ key: options.channels.key, value })}
        />
        <MultiBrandsAndDelegations
          isClearable
          customClassNameContainer='side-menu-filters__selector'
          placeholder={I18n.t('dashboard_delegations')}
          currentBrands={options.brandsAndDelegations.value?.brands || []}
          currentDelegations={options.brandsAndDelegations.value?.delegations || []}
          onChange={value => onChangeFilter({ key: options.brandsAndDelegations.key, value })}
        />
      </div>
    </div>
  )
}

export default SideMenuFilters
